import { render, staticRenderFns } from "./CustomerDashboardComponent.vue?vue&type=template&id=ab997dde&scoped=true"
import script from "./CustomerDashboardComponent.vue?vue&type=script&lang=js"
export * from "./CustomerDashboardComponent.vue?vue&type=script&lang=js"
import style0 from "./CustomerDashboardComponent.vue?vue&type=style&index=0&id=ab997dde&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab997dde",
  null
  
)

export default component.exports